/* eslint-disable no-underscore-dangle */
import { combineReducers } from 'redux';
import { call, takeEvery } from 'redux-saga/effects';
import { SubmissionError } from 'redux-form';
import request from '../api-utils/request';
import actionKey from '../utils/action-key';
import { trackPUAnalytics } from '../services/Mixpanel';

const GET_QUESTIONS = 'demographic/GET_QUESTIONS';
export const SAVE_QUESTIONS = 'demographic/SAVE_QUESTIONS';

export const getQuestionsAction = userId => ({
    type: GET_QUESTIONS,
    payload: userId,
});

export const saveQuestionsAction = ({ questions, answers, userId }, { resolve, reject } = {}) => ({
    type: SAVE_QUESTIONS,
    payload: {
        questions,
        answers,
        userId,
    },
    resolve,
    reject,
});

const questionsReducer = (state = [], action) => {
    switch (action.type) {
        case GET_QUESTIONS:
            return [];
        case actionKey.success(GET_QUESTIONS):
        case actionKey.success(SAVE_QUESTIONS):
            return action.payload.questions;
        default:
            return state;
    }
};

const assessmentReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_QUESTIONS:
            return {};
        case actionKey.success(GET_QUESTIONS):
            return action.payload;
        default:
            return state;
    }
};

const loadingQuestionsReducer = (state = false, action) => {
    switch (action.type) {
        case GET_QUESTIONS:
            return true;
        case actionKey.success(GET_QUESTIONS):
        case actionKey.failure(GET_QUESTIONS):
            return false;
        default:
            return state;
    }
};

const loadingQuestionsErrorReducer = (state = null, action) => {
    switch (action.type) {
        case GET_QUESTIONS:
        case actionKey.success(GET_QUESTIONS):
            return null;
        case actionKey.failure(GET_QUESTIONS):
            return action.error;
        default:
            return state;
    }
};

export default combineReducers({
    assessment: assessmentReducer,
    questions: questionsReducer,
    loadingQuestions: loadingQuestionsReducer,
    loadingQuestionsError: loadingQuestionsErrorReducer,
});


function* getQuestions({ type, payload }) {
    // values
    const query = payload ? `?userId=${payload}` : '';
    yield call(request, {
        type,
        url: `/api/demographic/questions${query}`,
    });
}


function* saveQuestions({ type, payload, resolve, reject }) {
    const { questions, answers, userId } = payload;
    const body = {};
    const qnaObj = {};
    questions.forEach((q) => {
        const questionId = q.demographicQuestionID_PK;
        const key = `question-${questionId}`;
        let response = answers[key];
        if (!response) {
            return;
        }
        if (!Array.isArray(response)) {
            response = [response];
        }

        response = response.map((a) => {
            if (q.options && q.options.length > 0) {
                const option = q.options.find(o => (
                    o.demographicOptionID_PK === Number(a)
                ));
                if (option) {
                    return {
                        demographicOptionID_FK: option.demographicOptionID_PK,
                        answer: option.option,
                    };
                }
            }
            if (q.type === 'select-subject-area') {
                return {
                    answer: a && a.label ? a.label : a,
                };
            }
            return {
                answer: a,
            };
        });
        body[questionId] = response;
        qnaObj[q.group] = { ...(qnaObj[q.group] || {}), [q.question]: Array.isArray(response) ? response.map((e) => e.answer).join(', ') : response };
    });
    const flattenedData = {};
    for (const [category, subData] of Object.entries(qnaObj)) {
        for (const [key, value] of Object.entries(subData)) {
            flattenedData[`${category} - ${key}`] = value;
        }
    }
    yield call(trackPUAnalytics, 'PathwayU:User Details', { ...flattenedData, action: 'Submit' });
    const query = userId ? `?userId=${userId}` : '';
    const res = yield call(request, {
        type,
        url: `/api/demographic/responses${query}`,
        options: {
            method: 'POST',
            body,
        },
    });

    if (res.error && reject) {
        reject(new SubmissionError({
            _error: res.error,
        }));
    } else if (!res.error && resolve) {
        resolve(res.payload);
    }
}


export function* rootSaga() {
    yield [
        takeEvery(GET_QUESTIONS, getQuestions),
        takeEvery(SAVE_QUESTIONS, saveQuestions),
    ];
}



// WEBPACK FOOTER //
// ./src/client/redux/demographic.js